module.exports = __webpack_public_path__ + "img/ic-trash.4c7c47dd.svg";